// extracted by mini-css-extract-plugin
module.exports = {"seoContentStyles":"az_SHb"};